import React, { useMemo } from 'react'

interface Props {
  url?: string
  autoplay?: number
}

function Vimeo(props: Props) {
  const { url, autoplay } = props
  const videoId = useMemo(() => {
    const match = url?.match(
      /(?:\/(?:channels\/[\w]+|(?:(?:album\/\d+|groups\/[\w]+)\/)?videos?))?\/(\d+)/i,
    )

    return match ? match[1] : null
  }, [url])

  if (!videoId) {
    return null
  }

  return (
    <iframe
      id="vimeoplayer"
      title="vimeo"
      width="100%"
      height="100%"
      src={`https://player.vimeo.com/video/${videoId}?autoplay=${(autoplay || 0)}`}
      frameBorder="0"
    />
  )
}

export default Vimeo
